<template>
  <div 
    v-if="popupOpen"
    class="sm-popup"
    :class="{
      'sm-popup--centered-content': centeredContent,
      'no-scroll': noScroll && !isMobile
    }"
    @mousedown="closePopup"
  >
    <div 
      v-if="!isMobile"
      class="sm-popup__desktop"
      :class="[
        size ? `sm-popup--${size}` : ''
      ]"
      ref="popup"
      @mousedown.stop
    >
      <a 
        href="#"
        class="sm-popup__desktop-close"
        @click.prevent="closePopup"
      >
      </a>
      <div class="sm-popup__desktop-content">
        <slot name="popupContent"></slot>
      </div>
    </div>
    <div 
      v-else
      class="sm-popup__mobile"
      @mousedown="closePopup"
      ref="popup"
    >
      <div 
        class="sm-popup__mobile-top"
        @mousedown.stop
      >
        <a 
          href="#"
          class="sm-popup__mobile-top-close"
          @click.prevent="closePopup"
        >
        </a>
      </div>
      <div 
        class="sm-popup__mobile-content"
        @mousedown.stop
      >
        <slot name="popupContent"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'popup-block',
  data() {
    return {
      popupOpen: this.open,
      centeredContent: false,
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default'
    },
    noScroll: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  created() {
    this.handleShow();

    window.addEventListener('resize', this.checkNoScroll);
  },
  mounted() {
    const popup = this.$refs.popup;

    this.centeredContent = popup.offsetHeight < window.innerHeight - 20;
    this.checkNoScroll();
  },
  destroyed() {
    this.handleHide();
    window.removeEventListener('resize', this.checkNoScroll);
  },
  activated() {
    this.handleShow();
    this.checkNoScroll();
  },
  deactivated() {
    this.handleHide();
  },
  methods: {
    ...mapActions({
      setPopupState: 'setPopupState'
    }),
    closePopup() {
      this.$emit('close');
    },
    pressEsc(e) {
      if (e.keyCode === 27)
        this.closePopup();
    },
    handleShow() {
      document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keyup', this.pressEsc);
      this.setPopupState(true);
    },
    handleHide() {
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
      document.removeEventListener('keyup', this.pressEsc);
      this.setPopupState(false);
    },
    checkNoScroll() {
      let popup = this.$refs.popup;
      let popupContent = popup.querySelector('.sm-popup__desktop-content');

      if (!popup || !popupContent)
        return;

      this.noScroll = (popupContent.scrollHeight + 80) < window.innerHeight;
    }
  }
}
</script>
